/* eslint react/prop-types: 0 */
import { useEffect } from "react";

/**
 * iter124 - Global JSON-LD Organization + WebSite schema injection.
 *
 * Mounted once at the app root so every page emits brand-level structured
 * data. This is what makes Google show the Knowledge-Panel-style block
 * with the SpectraLearn logo, founder, and social links in SERPs. Article
 * schema for individual blog posts is still injected per-page by
 * BlogPost.jsx - these two layers complement each other and do not conflict.
 */
export default function OrganizationSchema() {
  useEffect(() => {
    const ld = document.createElement("script");
    ld.type = "application/ld+json";
    ld.setAttribute("data-org-jsonld", "1");
    ld.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://spectralearn.co/#organization",
          "name": "SpectraLearn",
          "url": "https://spectralearn.co",
          "logo": "https://spectralearn.co/logo.png",
          "description":
            "Clinical-grade SpectraMind tools for neurodiverse learners. Social stories, IEP goals, behaviour support plans, visual schedules, and worksheets grounded in Carol Gray, TEACCH, PBIS, NICE NG87, and BDA frameworks.",
          "founder": {
            "@type": "Person",
            "name": "Neha Kishore",
            "jobTitle": "RCI-certified Special Educator & Co-founder",
            "sameAs": [
              "https://www.linkedin.com/company/spectralearn",
            ],
          },
          "foundingDate": "2024",
          "contactPoint": {
            "@type": "ContactPoint",
            "email": "support@spectralearn.co",
            "contactType": "customer support",
            "areaServed": ["US", "GB", "CA", "AU", "IN"],
            "availableLanguage": ["en"],
          },
          "sameAs": [
            "https://www.linkedin.com/company/spectralearn",
          ],
        },
        {
          "@type": "WebSite",
          "@id": "https://spectralearn.co/#website",
          "url": "https://spectralearn.co",
          "name": "SpectraLearn",
          "publisher": { "@id": "https://spectralearn.co/#organization" },
          "potentialAction": {
            "@type": "SearchAction",
            "target": {
              "@type": "EntryPoint",
              "urlTemplate": "https://spectralearn.co/blog?q={search_term_string}",
            },
            "query-input": "required name=search_term_string",
          },
        },
      ],
    });
    document.head.appendChild(ld);
    return () => { ld.remove(); };
  }, []);
  return null;
}
